import { ApiUrl } from './api-url';
import { Credentials } from './credentials';

export class ApiConfig {
  apiEnv: string;
  loginApp: string;
  storeTokenUrl: string;
  apiUrls: ApiUrl[] = [];
  timeExpired: number;
  credentials: Credentials;
  authService: any;
  errorHandler: any;
  loggerService: any;
}
